// @flow
import { APICore } from './apiCore';
import config from '../../config';

const api = new APICore();

function createSquareIntegrationAndStartOAuth(integrationRequest: any): any {
    const query = new URLSearchParams({ integrationName: integrationRequest.integrationName });
    const baseUrl = `${config.INTEGRATIONS_URL}/square/auth?${query.toString()}`;
    return api.create(baseUrl, {}).then(response => {
        if (response.data.authPageUrl) {
            return { redirected: true, url: response.data.authPageUrl };
        }
        throw new Error('Square authorization URL was not returned');
    });
}

export { createSquareIntegrationAndStartOAuth };
